//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 10.09.2015.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngInPlaceExpandable', srsngInPlaceExpandable);

    function srsngInPlaceExpandable() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/in-place-expandable/in-place-expandable.html',
            transclude: true,
            scope: {
                direction: '@'
            },
            controller: controller,
            link: link
        };

        function controller($scope) {
            // this is intentional override
        }

        function link(scope, element, attrs) {
            if (_.includes(scope.direction, 'left')) {

            }
        }
    }
})();